// Libraries
import { Box, CardMedia, Typography } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";

// Custom
import GutterImage from "Custom/Content/ProductSelector/gutter.png";

import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { GutterSystemStyle } from "./GutterSystemStyle";

import { isNullOrUndefined } from "Custom/Utils/Utils";

import { DelcoteProducts } from "./GutterSystemSubViews/DelcoteProducts";
import { PlygeneProducts } from "./GutterSystemSubViews/PlygeneProducts";

import { BQSRadioButton } from "./../../Primitives/RadioButtons/BQSRadioButton";
import { BQSRadioButtons } from "./../../Primitives/RadioButtons/BQSRadioButtons";
import { BQSRow } from "./../../Primitives/Row/BQSRow";

import { GutterSystemViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemViewModel";

interface IProps {
    className?: string;
    viewModel: GutterSystemViewModel;
}

export const GutterSystem: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const typopgraphyVariants = TypographyVariants();
    const gutterSystemStyle = GutterSystemStyle();

    const getClassName = (value: string): string => {
        return classNames({
            [`${gutterSystemStyle.radioButton}`]: true,
            [`${gutterSystemStyle.radioButtonPlygene}`]: value === "id_plygene",
            [`${gutterSystemStyle.radioButtonDelcote}`]: value === "id_delcotegs",
        });
    };

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={gutterSystemStyle.root}>
            <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                Choose your gutter system
            </Typography>
            <BQSRadioButtons
                className={gutterSystemStyle.radioButtons}
                displayName=""
                execute={props.viewModel.setProductSelection}
                value={!isNullOrUndefined(props.viewModel.productSelection) ? props.viewModel.productSelection.value : undefined}
            >
                {props.viewModel.products.map((item) => (
                    <BQSRadioButton className={getClassName(item.value)} displayName={item.title} displayNamePlacement="top" key={item.value} value={item.value} />
                ))}
            </BQSRadioButtons>
            <BQSRow className={gutterSystemStyle.products}>
                <Box>
                    <CardMedia className={gutterSystemStyle.gutterimage} image={GutterImage} title="Gutters" />
                </Box>
                <Box>
                    {props.viewModel.canDisplayPlygeneProducts && (
                        <PlygeneProducts commonViewModel={props.viewModel.ProductsCommonViewModel} viewModel={props.viewModel.PlygeneProductsViewModel} />
                    )}
                    {props.viewModel.canDisplayDelcoteProducts && (
                        <DelcoteProducts commonViewModel={props.viewModel.ProductsCommonViewModel} viewModel={props.viewModel.DelcoteProductsViewModel} />
                    )}
                </Box>
            </BQSRow>
        </Box>
    ));

    // #endregion Render Result
};
